import { GalleryItem } from './../models/gallery-item';
import { Injectable } from '@angular/core';
import { FavouriteService } from 'src/app/services/favourite.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from 'ionic-cache';
import * as Constants from '../app.constants';
import { ElencoItinerari } from '../models/elenco-itinerari';
import { Itinerario } from '../models/itinerario';
import { ItinerarioSummary } from '../models/itinerario-summary';

import { ItinerarioStop } from '../models/itinerario-stop';
import { environment } from 'src/environments/environment';
import { MultiTenantService } from './multi-tenant.service';
import { Category } from '../models/category';
import { SearchPage } from '../pages/search/search.page';
import { Image } from '@ks89/angular-modal-gallery';

@Injectable({
  providedIn: 'root'
})
export class ItineraryService {
  constructor(private favouriteService: FavouriteService, 
    private multiTenantService: MultiTenantService,
    
    private translateService: TranslateService, 
    private httpClient: HttpClient, 
    private cache: CacheService) {
  }

  loadFromCache(path) {
    if ( !this.cache ) {
      console.error('cache ERROR!');
    }
    

    this.cache.enableCache(true);

    this.cache.setDefaultTTL(60 * Constants.TTL_ITINERARY);
    let headers = new HttpHeaders({
      'Accept-Language': this.translateService.currentLang
    });
    let options = { headers: headers };

    let cacheKey = path + '&' + this.translateService.currentLang;
    let request = this.httpClient.get(path, options);
    return this.cache.loadFromObservable(cacheKey, request);
  }

  formatIndirizzoEsteso(stop: ItinerarioStop) {
    let indirizzoEsteso = ``;
    if (stop) {

      let indirizzo = '';
      let comune = '';
      let provincia = '';

      if (stop.address) {
        indirizzo = indirizzo.concat(stop.address);
        if (stop.nhouse && stop.nhouse != '0') {
          indirizzo = indirizzo.concat(`, ${stop.nhouse}`);
        }
      }
      if (stop.city) {
        comune = stop.city;
      }
      if (stop.province) {
        provincia = provincia.concat(` (`, stop.province, `)`);
      }

      switch (Constants.MODE_APP_LOCALE) {
        case Constants.MODE_APP_LOCALE_CITY_ADDRESS:
          indirizzoEsteso = indirizzo.concat(` - `, comune, ``);
          break;
        case Constants.MODE_APP_LOCALE_CITY:
          indirizzoEsteso = comune;
          break;
        case Constants.MODE_APP_LOCALE_ADDRESS:
          indirizzoEsteso = indirizzo;
          break;      
        default:
          break;
      }

    }

    return indirizzoEsteso;
  }



  getItineraries(page?, size?) {
    return new Promise((resolve, reject) => {
      //console.log('Itinerary - getItineraries');


      const path = `${Constants.API_BASE_URL}${Constants.BASE_ITINERARY_URL}${Constants.LIST_ITINERARY_URL}?landId=${environment.api.tenantId}&page=${page}&size=${size}`;

      this.loadFromCache(path).subscribe(
        async (res: any) => {
          const elencoItinerari = new ElencoItinerari();
          elencoItinerari.elenco = res.content;
          elencoItinerari.page = res.number;
          elencoItinerari.size = res.size;
          elencoItinerari.maximumPages = res.totalPages;
          elencoItinerari.totalElements = res.totalElements;

          const obj = elencoItinerari.elenco;

          for (const key in obj) {
            if (obj[key]) {
              if (obj[key].stops) {
                for (const stop of obj[key].stops) {
                  stop.indirizzoEsteso = this.formatIndirizzoEsteso(stop);
                }
              }

              //Recupero i favourite dallo storage
              obj[key].isFavourite = await this.favouriteService.isFavorite(obj[key].id, obj[key].typeElement.key);
              //console.log('Itinerario:' + obj[key].title + ' FAVORITO:' +  obj[key].isFavourite);
            
            }
          }

          resolve(elencoItinerari);
        },
        err => {
          console.error('Lista vuota');

          reject(new ElencoItinerari());
        }
      );
    });
  }




 getSummaryItinerariesByCat( categories : Array<Category>) {
    return new Promise((resolve, reject) => {
     
      console.log('getSummaryItinerariesByCat');

      let list = [];

      let summary: ItinerarioSummary;
      let resolvedFinal =  Promise.all(categories.map( async( value ) => {
        const result = await this.search(null,value.id , null,0,100,null,null);
        summary = new ItinerarioSummary();
        summary.category = value;

        //L'elenco viene inviato in modo mescolato
        summary.elenco = this.shuffleArray( result.elenco );
        list.push( summary );

        return result; // important to return the value
      } ) ).then( res => {
        resolve( list );
      }, err => {
        console.error('errore');
      });
    });
  }

  shuffleArray(array) {
    var m = array.length, t, i;
  
    // While there remain elements to shuffle
    while (m) {
      // Pick a remaining element…
      i = Math.floor(Math.random() * m--);
  
      // And swap it with the current element.
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }
  
    return array;
  }



 async getSummaryItineraries() {
    return new Promise((resolve, reject) => {
      this.multiTenantService.getCategoriesItinerary().then( async (categories : Array<Category>)  => {
             
        let list = [];

        let summary: ItinerarioSummary;
        let resolvedFinal = await Promise.all(categories.map( async( value ) => {
          const result = await this.search(null,value.id , null,null,3,null,null);
          summary = new ItinerarioSummary();
          summary.category = value;
          summary.elenco = result.elenco;
          list.push( summary );

          return result; // important to return the value
        } ) );
        resolve( list );
      }); 
    });
  }



  getItinerary(itinerary: Itinerario) {
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}${Constants.BASE_ITINERARY_URL}${Constants.LIST_ITINERARY_URL}${itinerary.id}?landId=${environment.api.tenantId}`;
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          if (res) {
            let mediaServerLandUrl = `?landId=${environment.api.tenantId}`;
            let mediaServerBaseURL =
              Constants.API_BASE_URL +
              Constants.BASE_MEDIA_URL +
              Constants.MEDIASERVER_DOWNLOAD_URL;


              /**
               * Recupero la Gallery - Converto Mappa in Array
               */
               res.galleryImages = [];

               if ( res.gallery ) {
                 let mapGallery = new Map(Object.entries( res.gallery ));
                 mapGallery.forEach( (element:GalleryItem,key) => {
                     
                 res.galleryImages.push( new Image(+key,      {
                     img: mediaServerBaseURL + element.image + mediaServerLandUrl,
                     description: element.captionGalleryImg
                   },
                   {
                     img: mediaServerBaseURL + element.thumbnail + mediaServerLandUrl,
                     title: element.captionGalleryImg,
                     alt: element.captionGalleryImg,
                     ariaLabel: element.captionGalleryImg,
                   }) );
                 });
               }



            for (const stop of res.stops) {
              stop.indirizzoEsteso = this.formatIndirizzoEsteso(stop);
            }

            //Recupero i favourite dallo storage
            res.isFavourite = await this.favouriteService.isFavorite(res.id, res.typeElement.key);
        
            resolve(res);

          } else {
            console.error('Itineario non trovato');

            reject();
          }

        },
        err => {
          console.log(err);
          console.error('Lista vuota');
          reject(new Itinerario());
        }
      );
    });
  }

  getItineraryById(id: string) {
    const itinerario = new Itinerario();
    itinerario.id = id;
    return this.getItinerary(itinerario);
  }

  search(title?: string, categoriesKey?: string, idsToExclude?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string) {
    let path = `${Constants.API_BASE_URL}${Constants.BASE_ITINERARY_URL}${Constants.LIST_ITINERARY_URL}?landId=${environment.api.tenantId}`;


    //console.log('search:' + title);
    if (title) {
      path = path.concat(`&title=${title}`);
    }
    if (categoriesKey) {
      path = path.concat(`&categoriesKey=${categoriesKey}`);
    }
    if (idsToExclude) {
      path = path.concat(`&idsToExclude=${idsToExclude}`);
    }
    if (page) {
      path = path.concat(`&page=${page}`);
    }
    if (size) {
      path = path.concat(`&size=${size}`);
    }
    if (sortBy) {
      path = path.concat(`&sortBy=${sortBy}`);
    }
    if (sortDirection) {
      path = path.concat(`&sortDirection=${sortDirection}`);
    }

    return new Promise<ElencoItinerari>((resolve, reject) => {
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          const elencoItinerari = new ElencoItinerari();
          elencoItinerari.elenco = res.content;
          elencoItinerari.page = res.number;
          elencoItinerari.size = res.size;
          elencoItinerari.maximumPages = res.totalPages;
          elencoItinerari.totalElements = res.totalElements;

          const obj = elencoItinerari.elenco;

          for (const key in obj) {
            if (obj[key]) {
              if (obj[key].stops) {
                for (const stop of obj[key].stops) {
                  stop.indirizzoEsteso = this.formatIndirizzoEsteso(stop);
                }
              }

              //Recupero i favourite dallo storage
              obj[key].isFavourite = await this.favouriteService.isFavorite(obj[key].id, obj[key].typeElement.key);
              //console.log('Itinerario:' + obj[key].title + ' FAVORITO:' +  obj[key].isFavourite);
            }
          }
          resolve(elencoItinerari);
        },
        err => {
          console.error('Lista vuota');

          reject(new ElencoItinerari());
        }
      );
    });
  }
}
